var _this = this;
import * as tslib_1 from "tslib";
import getStore from '../data/store/store';
import updateCalendarEventsToDecline from '../actions/updateCalendarEventsToDecline';
import { orchestrator } from 'satcheljs';
import updateCalendarViewItems from '../data/mutators/updateCalendarViewItems';
import getCalendarViewService from 'owa-calendar-services/lib/services/getCalendarViewService';
import { getStartDate, getEndDate } from '../selectors/getStoreProperties';
export default orchestrator(updateCalendarEventsToDecline, function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
    var optionState, startDate, endDate;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                optionState = getStore().currentState;
                if (!optionState.declineExistingCalendarEventsEnabled) return [3 /*break*/, 2];
                startDate = getStartDate();
                endDate = getEndDate();
                return [4 /*yield*/, getCalendarViewService(startDate, endDate).then(function (response) {
                        updateCalendarViewItems(response.Items);
                    })];
            case 1:
                _a.sent();
                _a.label = 2;
            case 2: return [2 /*return*/];
        }
    });
}); });
//# sourceMappingURL=onAutomaticReplyGetCalendarEventsToDeclineOrchestrator.js.map